/** Runtime marketplace nav visibility — deploy vendor mode plus tenant status. */

export type MarketplaceStatusSnapshot = {
  enabled: boolean;
  canManage: boolean;
};

export function isMarketplaceNavVisible(
  deployVendorMode: boolean,
  status: MarketplaceStatusSnapshot,
): boolean {
  if (!deployVendorMode) return false;
  return status.enabled || status.canManage;
}
